import React, { useEffect, useState } from 'react'
import { useOrder } from '../../hooks/useAuth'
import { LegalContact, LegalNav } from './legal-shared.components'
import './terms.styles.scss'

const PrivacyPolicy = () => {
  const { curPage } = useOrder()
  const [company, setCompany] = useState(curPage?.company || {})

  useEffect(() => {
    if (curPage?.company) setCompany(curPage.company)
  }, [curPage])

  return (
    <section className="legal-v2">
      <div className="legal-v2__glow legal-v2__glow--a" aria-hidden="true" />
      <div className="legal-v2__glow legal-v2__glow--b" aria-hidden="true" />

      <div className="legal-v2__inner">
        <div className="legal-v2__intro">
          <p className="legal-v2__eyebrow">Policies</p>
          <h1>
            <span className="legal-v2__script">Privacy</span>
            <span className="legal-v2__solid">policy</span>
          </h1>
          <p className="legal-v2__lead">
            How Cake by Sandy collects, uses, and looks after the information you share with us.
          </p>
          <LegalNav />
        </div>

        <article className="legal-v2__panel">
          <p className="legal-v2__updated">Last updated: July 21, 2026</p>

          <p>
            Your privacy matters to us. This policy explains what we collect through the Cake by
            Sandy website and how we use it.
          </p>

          <h2>1. Information we collect</h2>
          <p>
            We collect information you provide when you submit a booking request or inquiry. That may
            include your name, email address, phone number, event date, delivery or pickup details,
            and message content. We do not collect payment card details on this website.
          </p>

          <h2>2. How we use your information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Review and respond to booking requests and inquiries</li>
            <li>Confirm order details and communicate about your bake</li>
            <li>Improve our website and customer experience</li>
            <li>Send optional updates only if you ask for them</li>
          </ul>

          <h2>3. How we store and protect information</h2>
          <p>
            Inquiry and order details are stored in our business systems (including Firebase) so we
            can manage requests. We limit staff access to people who need it to help you. No online
            system is perfectly secure, so please avoid sending sensitive payment details through the
            contact form.
          </p>

          <h2>4. Sharing your information</h2>
          <p>
            We do not sell your personal information. We may share details with trusted providers
            that help us run the site or send email (for example hosting or mail delivery), only as
            needed to operate the business and respond to you.
          </p>

          <h2>5. Your choices</h2>
          <p>
            You can ask us to access, update, or delete personal information we hold about you by
            contacting us. If we email you promotions in the future, you can opt out using the
            instructions in that message.
          </p>

          <h2>6. Changes to this policy</h2>
          <p>
            We may update this privacy policy from time to time. The latest version will always be
            posted on this page with an updated date.
          </p>

          <h2>7. Contact</h2>
          <LegalContact company={company} />

          <p className="legal-v2__thanks">
            Thank you for trusting Cake by Sandy with your information.
          </p>
        </article>
      </div>
    </section>
  )
}

export default PrivacyPolicy
